import React, { Component, Suspense, lazy } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actions from '../actions';
import Header from './Header';
import Dashboard from './Dashboard';
import About from './About';
import Events from './Events';
import Donate from './Donate';
import Footer from './Footer';
import Projects from './Projects';
import './App.css';

// Lazy load the Alumnis component
const Alumnis = lazy(() => import('../features/alumni/Alumnis'));

class App extends Component {
  componentDidMount() {
    this.props.fetchUser();
    //this.props.fetchTweets();
  }

  render() {
    return (
      <div className="container">
        <BrowserRouter>
          <div>
            <Header />
            <Route exact path="/" component={Dashboard} />
            <Suspense fallback={<div>Loading alumni page...</div>}>
              <Route exact path="/alumnis" component={Alumnis} />
            </Suspense>
            <Route exact path="/events" component={Events} />
            {/* <Route exact path="/events2" component={Events2}/> */}
            <Route exact path="/donate" component={Donate} />
            <Route exact path="/about" component={About} />
            <Route exact path="/projects" component={Projects} />
            <Footer />
          </div>
        </BrowserRouter>
      </div>
    );
  }
}

 const mapStateToProps = (state) => ({
      user: state.auth.user,
  });

export default connect(mapStateToProps, actions)(App);

